export const cleanObject = (object: any) => {
  Object.keys(object).forEach((key) => {
    if (object[key] && typeof object[key] === "object")
      cleanObject(object[key]);
    // recurse
    else if (
      object[key] === null ||
      object[key] === undefined ||
      object[key] === ""
    )
      delete object[key]; // delete
  });
  return object;
};
